import { GET_CITIES, GET_STATE_LIST } from './ApiConstants';
import api from './ApiHandler';

export const getCities = async (payload: any) => {
  return await api.get(GET_CITIES, { params: payload });
};

export const getStates = async (payload: any) => {
  return await api.get(GET_STATE_LIST, { params: payload });
};
